import React, { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { api, customerReqConfig } from "../../include/api"
import { CUSTOMER, ERROR, SUCCESS } from "../../include/constant"
import { getCustomer, preventClick, setToLocalStorage, validateEmail, validatePhoneNumber } from "../../include/function"
import { useNotification } from "../../Toast/ToastProvider"

const CustomerPersonalInfo = () => {
  const toast = useNotification();
  // const history = useNavigate();
  const user = getCustomer();

  const [name, setName] = useState(user.name);
  const [emailId, setEmailId] = useState(user.emailId);
  const [phoneNumber, setPhoneNumber] = useState(user.phoneNumber);
  const [customerType, setCustomerType] = useState(user.customerType);

  const [nameError, setNameError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [emailIdError, setEmailIdError] = useState("");
  const [customerTypeError, setCustomerTypeError] = useState("");

  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);

  const handleName = (value) => {
    setNameError("");
    setName(value);
  };

  const handleEmailId = (value) => {
    setEmailIdError("");
    setEmailId(value);
  };

  const handlePhoneNumber = (value) => {
    setPhoneNumberError("");
    setPhoneNumber(value);
  };

  // const handleCustomerType = (value) => {
  //   setCustomerTypeError("");
  //   setCustomerType(value);
  // };

  const setDefault = () => {
    setName(user.name);
    setEmailId(user.emailId);
    setPhoneNumber(user.phoneNumber);
    setCustomerType(user.customerType);
  };

  const handleEdit = () => {
    let error = false;
    const data = {
      id: String(user.id).trim(),
      name: String(name).trim(),
      emailId: String(emailId).trim().toLowerCase(),
      phoneNumber: String(phoneNumber).trim(),
      customerType: customerType,
    };

    if (data.name === "") {
      setNameError("Name required");
      error = true;
    }

    if (data.phoneNumber === "") {
      setPhoneNumberError("Phone number required");
      error = true;
    }

    if (data.emailId !== "" && !validateEmail(data.emailId)) {
      setEmailIdError("Invalid email address");
      error = true;
    }

    if (data.name.length > 100) {
      setNameError("Name is too long");
      error = true;
    }

    if (!validatePhoneNumber(data.phoneNumber)) {
      setPhoneNumberError("Invalid phone number");
      error = true;
    }

    // Customer type validation
    // if (!data.customerType) {
    //   setCustomerTypeError("Customer type required");
    //   error = true;
    // }

    if (!error) {
      setLoading(true);
      api
        .put("/customer/?id=" + user.id, data, customerReqConfig())
        .then((response) => {
          if (response.status === 200) {
            setToLocalStorage(CUSTOMER, data);
            toast({ type: SUCCESS, message: response.data.message });
            setEdit(false);
            //   setTimeout(() => {
            //     history.push("/profile");
            //   }, 500);
          }
        })
        .catch((error) => {
          error.response
            ? toast({ type: ERROR, message: error.response.data.message })
            : toast({ type: ERROR, message: error.message });
        })
        .finally(() => setLoading(false));
    }
  };

  const toggleEdit = () => {
    setEdit(!edit);
    setNameError("");
    setPhoneNumberError("");
    setEmailIdError("");
    // setCustomerTypeError("");
    setDefault();
  };

  return <div className="container">
    <div className="p-32">
      <h6 className="text-xl mb-32">Edit Profile</h6>
      <div className="mb-10">
        <h6
          className="text-md mb-16 fw-bold "
        >Name</h6>
        <input type="text" className={`form-control ${!edit ? 'cursor-no-drop' : ''} ${nameError !== '' && 'border-danger'}`} value={name} onChange={e => handleName(e.target.value)} placeholder="Name"
          style={{
            bordeRadius: " 5px",
            fontWeight: " 400",
            outline: " none",
            width: " 100%",
            padding: " 17px 24px",
            backgroundColor: " transparent !important",
            border: " 1px solid var(--gray-100)",
            color: " hsl(var(--black))",
            lineHeight: " 1",
          }} />
        <span className="text-danger my-2 small fw-bold">{nameError}</span>
        <br />
      </div>
      <div className="mb-10">
        <h6
          className="text-md mb-16 fw-bold "
        >Email Address</h6>
        <input type="email" className={`form-control ${'cursor-no-drop'} ${emailIdError !== '' && 'border-danger'}`} value={emailId} placeholder="Email Address"
          style={{
            bordeRadius: " 5px",
            fontWeight: " 400",
            outline: " none",
            width: " 100%",
            padding: " 17px 24px",
            backgroundColor: " transparent !important",
            border: " 1px solid var(--gray-100)",
            color: " hsl(var(--black))",
            lineHeight: " 1",
          }} />
        <span className="text-danger my-2 small fw-bold">{emailIdError}</span>
        <br />
      </div>
      <div className="mb-10">
        <h6
          className="text-md mb-16 fw-bold "
        >Mobile Number</h6>
        <input type="number" className={`form-control ${'cursor-no-drop'} ${phoneNumberError !== '' && 'border-danger'}`} value={phoneNumber} placeholder="Mobile Number"
          style={{
            bordeRadius: " 5px",
            fontWeight: " 400",
            outline: " none",
            width: " 100%",
            padding: " 17px 24px",
            backgroundColor: " transparent !important",
            border: " 1px solid var(--gray-100)",
            color: " hsl(var(--black))",
            lineHeight: " 1",
          }} />
        <span className="text-danger my-2 small fw-bold">{phoneNumberError}</span>
        <br />
        <div className="d-flex gap-5">
          <Link
            className="btn btn-main ms-auto"
            to="#"
            onClick={e => preventClick(e, toggleEdit)}
          >
            {edit ? 'Cancel' : 'Update profile'}
          </Link>

          {edit && !loading && (
            <Link
              className="btn btn-main"
              to="#"
              onClick={e => preventClick(e, handleEdit)}
            >
              Save
            </Link>
          )}
        </div>
      </div>
    </div>

  </div>
}

export default CustomerPersonalInfo